import { useRouter } from 'next/router'

import validatePageNumber from '@/helpers/validatePageNumber'

function usePagination(totalItems: number, limit = 30) {
  const router = useRouter()

  const accessedPage = Number(router.query.page) || 1
  const maxPages = Math.ceil(totalItems / limit)
  const validPage = validatePageNumber(accessedPage, maxPages)
  const pageCount = maxPages <= 1 ? 1 : maxPages

  const offset = validPage <= 0 ? 0 : (validPage - 1) * limit

  return { page: validPage, pageCount, limit, offset }
}

export default usePagination
